<template>
  <v-menu
    v-if="videosAyudaVisibles.length > 0"
    bottom
    right
    fixed
  >
    <template v-slot:activator="{ on }">
      <v-btn
        flat
        icon
        small
        :color="color"
        v-on="on"
      >
        <v-icon>live_help</v-icon>
      </v-btn>
    </template>

    <v-list>
      <v-list-tile
        v-for="(video, key) in videosAyudaVisibles"
        :key="key"
        @click="mostrarVideoAyuda(video)"
      >
        <v-list-tile-title>{{ video.titulo }}</v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'VideoAyudaMenu',
  props: {
    grupo: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: 'blue-grey'
    }
  },
  computed: {
    videosAyudaVisibles () {
      let videos = []
      if (this.grupo) {
        videos = this.$store.getters['videoAyuda/videosPorGrupo'](this.grupo)
      } else {
        videos = this.$store.getters['videoAyuda/videos']
      }

      return _.filter(videos, item => {
        return item.permisos[0] === '*' || this.$puedoAlguno(item.permisos)
      })
    }
  },
  data () {
    return {
      nombreGrupo: this.grupo
    }
  },
  methods: {
    mostrarVideoAyuda (video) {
      this.$store.dispatch('videoAyuda/mostrar', video)
    }
  },
  watch: {
    grupo (val) {
      this.nombreGrupo = val
    }
  }
}
</script>

<style lang="scss" scoped>
iframe {
  width: 100%;
  max-width: 650px; /* Also helpful. Optional. */
}
</style>
